import './UserSubscription.css'
import { useState, useEffect, ReactNode } from 'react'
import ConsoleNavMenu from '../ConsoleNavMenu';
import { Modal, Button } from 'react-bootstrap';
import {
    AstraModemSubscriptionData,
    AstraModemSubscriptionDataList,
    AstraModemSubscriptionListSchema,
    SubscriptionPlanDataList,
    SubscriptionPlanListSchema
} from '../../../api/AstraSubscription';
import { APIRequestGet, APIRequestPost } from '../../../utils/APIRequests';
import { PaymentInitRequestData, PaymentInitSchema } from '../../../api/Payment';

const UserSubscription = (): ReactNode => {
    const daysLeftForWarning = 10;
    const [subscriptions, setSubscriptions] = useState<AstraModemSubscriptionDataList>();
    const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
    const [subscriptionForRenewal, setSubscriptionForRenewal] = useState<AstraModemSubscriptionData>();
    const [subscriptionPlans, setSubscriptionPlans] = useState<SubscriptionPlanDataList>();

    useEffect(() => {
        APIRequestGet(`/astraSubscription/getSubscriptions`, {
            schema: AstraModemSubscriptionListSchema,
            logSuccess: true
        }).then((result) => {
            setSubscriptions(result.data);
        });

        APIRequestGet(`/astraSubscription/getPlans`, {
            schema: SubscriptionPlanListSchema,
            logSuccess: true
        }).then((result) => {
            setSubscriptionPlans(result.data);
        });
    }, []);

    function buySubscription(planId: string, subscriptionId: string): void {
        const data: PaymentInitRequestData = {
            planId,
            subscriptionId
        };

        APIRequestPost('/payment/init', {
            data: data,
            schema: PaymentInitSchema,
            logSuccess: true
        }).then((result) => {
            window.open(result.data.paymentURL, '_blank');
        });
    }

    return (
        <>
            <ConsoleNavMenu />
            <div className='max-width text-page-padding'>
                <div className="table-container">
                    <table className='user-subscriptions-table table table-striped' aria-labelledby="tableLabel">
                        <thead>
                            <tr>
                                <th style={{ width: "30%" }}>Устройство</th>
                                <th style={{ width: "30%" }}>Осталось дней</th>
                                <th style={{ width: "30%" }}>Срок действия</th>
                                <th style={{ width: "20%" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {subscriptions?.map(i =>
                                <tr key={i.modemName}>
                                    <td>{i.modemName}</td>
                                    <td>{i.daysLeft.toFixed()}</td>
                                    {i.isRotten ? (
                                        <td style={{ color: "red" }}>{i.timeDeactivation}</td>
                                    ) : (
                                        <>
                                            {i.daysLeft < daysLeftForWarning ? (
                                                <td style={{ color: "orange" }}>{i.timeDeactivation}</td>
                                            ) : (
                                                <td>{i.timeDeactivation}</td>
                                            )}
                                        </>
                                    )}
                                    <td>
                                        <button
                                            style={{ width: "100%" }}
                                            className="btn btn-primary"
                                            onClick={() => {
                                                setSubscriptionForRenewal(i);
                                                setShowSubscriptionPlans(true);
                                            }}
                                        >
                                            Продлить
                                        </button>
                                    </td>
                                    {/*<td><Link to={`/statistics/modem?imei=${i.imei}`}>{i.imei}</Link></td>*/}
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal size="lg" show={showSubscriptionPlans} onHide={() => { setShowSubscriptionPlans(false) }}>
                <Modal.Header style={{ backgroundColor: "#343434" }} closeButton>
                    <Modal.Title>Продление подписки {subscriptionForRenewal?.modemName}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "#343434" }}>
                    <div className='plans'>
                        {subscriptionPlans?.map((x) =>
                            <div className='plan' key={x.id}>
                                <div className='plans_row plans_name t-20'>{x.name}</div>
                                <div className='plans_row plans_price t-20'>Стоимость: {x.price} ₽</div>
                                <div>
                                    <Button
                                        style={{ width: "-webkit-fill-available" }}
                                        variant="primary"
                                        onClick={() => buySubscription(x.id, subscriptionForRenewal?.id ?? "")}
                                    >
                                        Оплатить
                                    </Button>
                                </div>
                            </div>)}
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ backgroundColor: "#343434" }}>
                    <Button variant="secondary" onClick={() => { setShowSubscriptionPlans(false) }}>
                        Закрыть
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UserSubscription;